<template>
    <div id="header">
        <div class="left">
            <div class="logo">
                <a class="xdicon xdicon-xdlogo" href="//www.xd.com"></a>
            </div>
            <div class="cut-line"></div>
            <div class="name">游戏转服</div>
        </div>
        <div class="home">
            <a href="//www.xd.com">返回官网</a>
        </div>
    </div>    
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
#header {
    height: 79px;
    border-bottom: 1px solid #eff1f2;
    color: #585858;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
        display: flex;
        align-items: center;
        .logo {
            margin-left: 40px;
            .xdicon-xdlogo {
                font-size: 25px;
            }
        }
        .cut-line {
            width: 1px;
            height: 20px;
            background-color: #c7c7c7;
            margin: 0 30px;
        }
    }
    .home {
        margin-right: 40px;
        a {
            display: inline-block;
            height: 100%;
            line-height: 80px;
            color: #585858;
        }
    }
}

@media screen and (max-width: 768px) {
    #header {
        .left {
            .logo {
                margin-left: 20px;
            }
            .cut-line {
                margin: 0 15px;
            }
        }
        .home {
            margin-right: 20px;
        }
    }
}
</style>